import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringOptionalProperty, StringRequired } from '../primitive/string';

/**
 * Triggered when a user submits shipping information during checkout
 * Based on: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#initiate_the_checkout_process
 */
export const GtmAddShippingInfoEventSchema = Schema.Struct({
  event: Schema.Literal('track.add_shipping_info'),
  ecommerce: Schema.Struct({
    currency: StringRequired,
    value: Number,
    coupon: StringOptionalProperty,
    shipping_tier: StringRequired,
    shipping_method_code: StringRequired,
    shipping_method_price: Number,
    shipping_placement_id: StringOptionalProperty,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmAddShippingInfoEventSchema' });

export type GtmAddShippingInfoEvent = Schema.Schema.Type<typeof GtmAddShippingInfoEventSchema>;
